
const GET_ASSIGNMENT_TYPES = "GET_ASSIGNMENT_TYPES";
const GET_ENVIRONMENTS = "GET_ENVIRONMENTS";
const GET_SINGLE_USER = "GET_SINGLE_USER";
const GET_USERS = "GET_USERS";
const LOGOUT = "LOGOUT";
const SET_ACTIVE_ENVIRONMENT_ID = "SET_ACTIVE_ENVIRONMENT_ID";

export { GET_ASSIGNMENT_TYPES, GET_ENVIRONMENTS, GET_SINGLE_USER, GET_USERS, LOGOUT, SET_ACTIVE_ENVIRONMENT_ID };
